import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { message, Upload } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
const ImageUploadList = ({ value = [], onChange, onRemove }) => {
    const handleBeforeUpload = (file) => {
        const isImage = file.type.startsWith('image/');
        if (!isImage) {
            message.error('You can only upload image files!');
        }
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isLt2M) {
            message.error('Image must be smaller than 2MB!');
        }
        return false;
    };
    const handleChange = ({ fileList }) => {
        onChange?.(fileList);
    };
    return (_jsx(Upload, { listType: "picture-card", multiple: true, fileList: value, beforeUpload: handleBeforeUpload, onChange: handleChange, onRemove: onRemove, showUploadList: {
            showPreviewIcon: false,
            showRemoveIcon: true, // Optional: Keeps the remove icon
        }, maxCount: 10, children: _jsxs("div", { children: [_jsx(PlusOutlined, {}), _jsx("div", { style: { marginTop: 8 }, children: "Upload" })] }) }));
};
export default ImageUploadList;
